<template>
<div class="info-sign" v-on:mouseover="showInfo" v-on:mouseout="hideInfo">
    <i class="sm-question" @click="showInfo"></i>
    <div class="info" :class="direction" :style="style" v-show="isShow">
        <slot>{{content}}</slot>
    </div>
</div>
</template>

<script type="text/javascript">
/**
 * ### 气泡信息提示
 *
 * @props
 * ** isShow
 *     - 是否显示气泡
 *    
 * ** hideOnLeave
 *     - 离开隐藏
 *  
 * @slot
 *     - 内容自动为气泡中内容
 */

import ui from '../base/ui'
import layer from '../base/layer'

const params = {
    isShow: false,
    hideOnLeave: true,
    direction: 'bottom',
    content: '信息'
}

export default {
    params: params,
    mixins: [ui, layer],
    watch: {
        direction (value) {
            // 在这里变化浮层方向
        }
    },
    methods: {
        showInfo () {
            this.isShow = true
        },
        hideInfo () {
            if (this.hideOnLeave) {
                this.isShow =  false
            }
        }
    }
}

</script>

<style type="text/css" lang="less">
.info-sign {
    position: relative;
    line-height: 1.5em;
    padding: 5px 0;
    display: inline;

    .info {
        width: 100px;
        min-height: 50px;
        box-sizing: border-box;
        position: absolute;
        background: #FFF;
        display: block;
        padding: 8px 16px;
        border: 1px solid rgba(34,36,38,.2);
        border-radius: 4px;
        box-shadow: 0 2px 3px rgba(34,36,38,.15);
        color: #333;
        font-size: 13px;
        font-weight: normal;
        line-height: 1.8;
        z-index: 999;
        &:after, &:before {
            content: '';
            position: absolute;
            border: 6px solid transparent;
        }
    }

    .info.left {
        left: -110px;
        top: -25px;
        &:after, &:before {
            right: -15px;
            top: 30px;
            margin-bottom: -20px;
            border-left-width: 10px;
        }
        &:before {
            margin-right: -2px;
            border-left-color: rgba(34,36,38,.2);
        }
        &:after {
            border-left-color: #FFF;
        }
    }

    .info.right {
        left: 20px;
        top: -25px;
        &:after, &:before {
            left: -15px;
            top: 30px;
            margin-bottom: -20px;
            border-left-width: 10px;
        }
        &:before {
            margin-left: -2px;
            border-right-color: rgba(34,36,38,.2);
        }
        &:after {
            border-right-color: #FFF;
        }
    }


    .info.bottom {
        top: 32px;
        left: -103px;
        width: 200px;
        &:after, &:before {
            content: '';
            position: absolute;
            left: 102px;
            top: -16px;
            border: 6px solid transparent;
            border-bottom-width: 10px;
        }
        &:before {
            margin-top: -2px;
            border-bottom-color: rgba(34,36,38,.2);
        }
        &:after {
            border-bottom-color: #FFF;
        }
    }

    .info.top {
        top: -55px;
        left: -103px;
        width: 200px;
        &:after, &:before {
            content: '';
            position: absolute;
            left: 102px;
            bottom: -16px;
            border: 6px solid transparent;
            border-top-width: 10px;
        }
        &:before {
            margin-bottom: -2px;
            border-top-color: rgba(34,36,38,.2);
        }
        &:after {
            border-top-color: #FFF;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Info.vue?83f06c8a